
import React, { useState } from 'react'
import Sidebar from '../components/Sidebar'
import TaskFilters from '../components/TaskFilters'
import MyTasksView from '../components/MyTasksView'
import DiscoverTasksView from '../components/DiscoverTasksView'
import ArchivedTasksView from '../components/ArchivedTasksView'

const Tasks = () => {
  const [selectedDomain, setSelectedDomain] = useState('')
  const [selectedModule, setSelectedModule] = useState('')
  const [selectedView, setSelectedView] = useState('')

  const handleDomainChange = (value: string) => {
    setSelectedDomain(value)
    setSelectedModule('') // Reset module when domain changes
  }

  const renderView = () => {
    switch (selectedView) {
      case 'my-tasks':
        return <MyTasksView />
      case 'discover-tasks':
        return <DiscoverTasksView 
          selectedDomain={selectedDomain} 
          selectedModule={selectedModule} 
        />
      case 'archived-tasks':
        return <ArchivedTasksView />
      default:
        return <MyTasksView />
    }
  }

  return (
    <div className="flex min-h-screen bg-gray-50">
      <Sidebar />
      
      <main className="flex-1 p-6">
        <div className="max-w-7xl mx-auto">
          <TaskFilters
            selectedDomain={selectedDomain}
            selectedModule={selectedModule}
            selectedView={selectedView}
            onDomainChange={handleDomainChange}
            onModuleChange={setSelectedModule}
            onViewChange={setSelectedView}
          />

          <div className="mt-6">
            {renderView()}
          </div>
        </div>
      </main>
    </div>
  )
}

export default Tasks
